/*****************************
 * UR-TOOLTIP
 *****************************/
function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}

const THROTTLE_TIMER_MOVE  = 100;
const THROTTLE_TIMER_ENTER = 50;

// 1. Prepare tooltip object :: Global once
var tooltip = document.createElement('div');
tooltip.className = 'ur-tooltip-directive';


export default {
    name : 'ur-tooltip',
    inserted(el, binding, vnode) {
        el.__tooltipX__ = 0;
        el.__tooltipY__ = 0;
        el.__tooltipTimer__ = null;
        el.__innerText__ = binding.value;
        var overflowFlag = binding.arg === 'overflow' || binding.modifiers.overflow;
        var emptyFlag    = binding.arg === 'empty'    || binding.modifiers.empty;
        var preFlag      = binding.arg === 'pre'      || binding.modifiers.pre;
        
        el.__tooltipMMove__ = throttle(function(e) {
            var x = e.clientX,
                y = e.clientY,
                w = tooltip.getBoundingClientRect().width,
                h = tooltip.getBoundingClientRect().height;
            var pos = getPos(x,y,w,h);
            tooltip.style.top    = pos.top;
            tooltip.style.bottom = pos.bottom;
            tooltip.style.left   = pos.left;
            tooltip.style.right  = pos.right;
            tooltip.style.opacity = (w&&h)?1:0;
            tooltip.setAttribute('direction',pos.direction);
            tooltip.setAttribute('__width',w);
        },THROTTLE_TIMER_MOVE);
        
        el.__tooltipMEnter__ = function (e) {
            // 1. skip : Overflow only
            if(overflowFlag && Math.ceil(el.getBoundingClientRect().width) >= el.scrollWidth) return
            // +1 tlqnfjf....
            // 1. skip : Empty tooltip
            //      - 기본값기능으로 할까? 0이랑 false 때문에...
            //      - 검색조건 넣으면 되는데...
            //      - TODO
            if(emptyFlag && !el.__innerText__) return
            
            el.addEventListener('mousemove',el.__tooltipMMove__);
            tooltip.innerText = el.__innerText__;
            el.__tooltipTimer__ = setTimeout(function() {
                var x = e.clientX, y = e.clientY,
                    w = tooltip.getBoundingClientRect().width,
                    h = tooltip.getBoundingClientRect().height;
                var pos = getPos(x,y,w,h);
                tooltip.style.top    = pos.top;
                tooltip.style.bottom = pos.bottom;
                tooltip.style.left   = pos.left;
                tooltip.style.right  = pos.right;
                tooltip.style.opacity = (w&&h)?1:0;
                tooltip.style['white-space'] = preFlag?'pre-wrap':'normal';
                tooltip.setAttribute('direction',pos.direction);
                tooltip.setAttribute('mounted','true');
                tooltip.setAttribute('__width',w);
                document.body.appendChild(tooltip);
            },THROTTLE_TIMER_ENTER)
        };
        el.__tooltipMLeave__ = function(e) {
            if(!el.__tooltipTimer__) return;
            clearTimeout(el.__tooltipTimer__);
            el.removeEventListener('mousemove', el.__tooltipMMove__);
            if(tooltip.getAttribute('mounted') === 'true') {
                tooltip.removeAttribute('mounted');
                document.body.removeChild(tooltip);
            }
        };
        el.addEventListener('mouseenter', el.__tooltipMEnter__);
        el.addEventListener('mouseleave', el.__tooltipMLeave__);
        //window.addEventListener('wheel', el.__tooltipMLeave__); /*wheel -> tooltip off -> 너무 많이 돌아 여기서 금지*/
    },
    componentUpdated(el, binding, vnode) {
        if(binding.value !== binding.oldValue) {
            el.__innerText__ = binding.value;
        }
    },
    unbind(el,binding,vnode) {
        if(el.__tooltipMLeave__ && typeof el.__tooltipMLeave__ === 'function'){
            el.__tooltipMLeave__();
        }
        el.removeEventListener('mouseenter', el.__tooltipMEnter__);
        el.removeEventListener('mouseleave', el.__tooltipMLeave__);
        //window.removeEventListener('wheel', el.__tooltipMLeave__); /*wheel -> tooltip off -> 너무 많이 돌아 여기서 금지*/
        if(el.hasOwnProperty('__tooltipMEnter__' )) delete el.__tooltipMEnter__;
        if(el.hasOwnProperty('__tooltipMLeave__' )) delete el.__tooltipMLeave__;
        if(el.hasOwnProperty('__tooltipMMove__'  )) delete el.__tooltipMMove__ ;
        if(el.hasOwnProperty('__tooltipX__'      )) delete el.__tooltipX__    ;
        if(el.hasOwnProperty('__tooltipY__'      )) delete el.__tooltipY__    ;
        if(el.hasOwnProperty('__tooltipTimer__'  )) delete el.__tooltipTimer__;
        if(el.hasOwnProperty('__innerText__'     )) delete el.__innerText__   ;
    }
}


function getPos(x,y,w,h) {
    var screenWidth  = document.body.clientWidth;
    var screenHeight = document.body.clientHeight;
    
    var pos ={}
    if(       x < screenWidth/4) { // left 25%
        pos.direction = "R"
    } else if(x > screenWidth/4*3) { // right 25%
        pos.direction = "L"
    } else if(y < screenHeight/2) {
        pos.direction = "D"
    } else {
        pos.direction = "U"
    }
    
    switch(pos.direction) {
    case "R":
        pos.top = (y - (h/2)+0) +'px';
        pos.bottom = '';
        pos.left = (x + 20) +'px';
        pos.right = '';
        break;
    case "L":
        pos.top = (y - (h/2)+4) +'px';
        pos.bottom = '';
        pos.left = '';
        pos.right = (screenWidth - x + 14) +'px';
        break;
    case "U":
        pos.top = '';
        pos.bottom = (screenHeight - y + 14) +'px';
        pos.left = (x - w/2) +'px';
        pos.right = '';
        break;
    case "D":
        pos.top = (y + 34) +'px';
        pos.bottom = '';
        pos.left = (x - w/2 + 4) +'px';
        pos.right = '';
        break;
    }
    return pos
}